// extracted by mini-css-extract-plugin
export default {"errorText":"Input_errorText__NjBxz","headerText":"Input_headerText__yvZsx","input":"Input_input__FXaex","border":"Input_border__6s0Ie","errorInput":"Input_errorInput__dxLU9"};